var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8116 11.1985L16.5666 8.65268C17.1508 8.25768 17.5 7.59851 17.5 6.89351V6.89351C17.5 5.71851 16.5483 4.76685 15.3741 4.76685H4.63828C3.46412 4.76685 2.51245 5.71851 2.51245 6.89268V6.89268C2.51245 7.59768 2.86162 8.25685 3.44578 8.65268L7.20078 11.1985C8.89495 12.3468 11.1175 12.3468 12.8116 11.1985V11.1985Z",
    stroke: "url(#paint0_linear_549_40403)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6.89258V14.7667C2.5 16.1476 3.61917 17.2667 5 17.2667H15C16.3808 17.2667 17.5 16.1476 17.5 14.7667V6.89341",
    stroke: "url(#paint1_linear_549_40403)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_549_40403",
    x1: 5.88464,
    y1: 4.76684,
    x2: 14.7117,
    y2: 7.02031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38B97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4904D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_549_40403",
    x1: 5.875,
    y1: 6.89258,
    x2: 14.9911,
    y2: 8.52997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38B97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4904D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.2796a8d6fba9677832084ca941e41fee.svg";
export { ForwardRef as ReactComponent };